import { useState } from 'react';
import useAsync from './async';
import {
  triggerUrlFinder,
  triggerUrlFinderByCsv,
} from '../api/services/entities';

export default function useUrlFinder() {
  const [showModal, setShowModal] = useState(false);
  const [isConfirmed, setIsConfirmed] = useState(false);
  const query = useAsync();

  function closeModal() {
    setShowModal(false);
  }

  function openModal() {
    setShowModal(true);
  }

  function trigger(data, byCSV = false) {
    setShowModal(true);
    const promise = byCSV ? triggerUrlFinderByCsv : triggerUrlFinder;
    return query.run(promise(data));
  }

  function confirm() {
    setIsConfirmed(true);
  }

  return {
    showModal,
    openModal,
    closeModal,
    trigger,
    query,
    isConfirmed,
    confirm,
  };
}
